import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Tooltip } from '@mui/material';
import React, { useEffect } from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import { getIcon, Icon } from '../../lib/icons';
import { scaleRange } from '../../constants/index';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import makeStyle from '@mui/styles/makeStyles';

const useStyle = makeStyle(() => ({
    rightrw: {
        border: '1px solid rgb(0, 123, 193)',
        borderRadius: '25px',
        top: '8px',
        position: 'relative',
        marginLeft: '4px',
        fontSize: '40px',
        color: PXBColors.blue[800],
    },
    enableArw: {
        opacity: 1,
        cursor: 'pointer',
    },
    disableArw: {
        opacity: 0.4,
        pointerEvents: 'none',
    },
    assist: {
        margin: '8px 18px',
        borderRadius: '3px',
        textAlign: 'center',
        width: '141px',
        padding: '7px',
        border: '1px solid #424E541F',
        position: 'absolute',
        color: PXBColors.blue[800],
        cursor: 'pointer',
        opacity: '1',
    },
}));

export const HeaderPRGraph: React.FC<{
    dataItem: any;
    setValues: (arg0: any) => void;
    setIndexValue: (arg0: any) => void;
    isDisabled?: boolean;
    girdAlign?: any;
    alarmSelectIndex?: any;
}> = (props) => {
    const classes = useStyle();
    const { t } = useLanguageLocale();
    const [selectedDateIndex, setdateTimeList] = React.useState(0);
    const [scaleIndex, setScaleIndex] = React.useState(0);
    
    useEffect(()=>{
        setdateTimeList(props.alarmSelectIndex);
     },[selectedDateIndex]);

    const dateHandleChange = (event: any): void => {
        setdateTimeList(event.target.value);
        props.setValues(event.target.value);
    };
 
    const LeftAw = getIcon('NavigateBefore');
    const RightAw = getIcon('NavigateNext');

    const PrevDate = (): void => {
        if (selectedDateIndex - 1 !== -1) {
            setdateTimeList(selectedDateIndex - 1);
            props.setValues(selectedDateIndex - 1);
        }
    };

    const NextDate = (): void => {        
        if (Number(selectedDateIndex) + 1 <= props.dataItem.length) {
            setdateTimeList(Number(selectedDateIndex) + 1);
            props.setValues(Number(selectedDateIndex) + 1);
        }
    };

    const scaleChange = (event: any): void => {
        setScaleIndex(event.target.value);
        props.setIndexValue(event.target.value);
    };
   

    return (
        <>
            <Grid item xs={3} style={{display : props.isDisabled === true ? 'none' : 'block'}}>
                <Box>
                <FormControl sx={{ m: 1, minWidth: 'auto',width:'97%' }} size="small">
                    <InputLabel id="demo-select-small">Date</InputLabel>
                    <Select
                        data-testid="dropdown-dateTime"
                        disabled={false}                       
                        value={selectedDateIndex}
                        label="Date"
                        id="demo-select-small"                      
                        onChange={dateHandleChange}
                        labelId="demo-select-small"
                                              
                    >
                        {props.dataItem.map((element: any, index: number) => (
                                <MenuItem key={index} value={index}>
                                    {element}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>   
                </Box>
            </Grid>
            <Grid item xs={3} style={{display : props.isDisabled === true ? 'none' : 'block'}}>
                <span className={selectedDateIndex - 1 !== -1 ? classes.enableArw : classes.disableArw}>
                    <LeftAw className={classes.rightrw} onClick={(): void => PrevDate()} />
                </span>
                <span
                    className={selectedDateIndex + 1 === props.dataItem.length ? classes.disableArw : classes.enableArw}
                >
                    <RightAw className={classes.rightrw} onClick={(): void => NextDate()} />
                </span>
            </Grid>
            <Grid item xs={2}>
                <FormControl style={{width:'100%'}} sx={{ m: 1, minWidth: 'auto' }} size="small">
                    <InputLabel id="Scale-select-filled-label">Scale</InputLabel>
                    <Select
                        data-testid="scale-option"
                        disabled={false}                       
                        value={scaleIndex}
                        label="Scales"                       
                        onChange={scaleChange}
                        labelId="Scale-select-filled-label"
                        id="Scale-select-filled"
                    >
                        {scaleRange.map((scale: any, index: number) => (
                            <MenuItem key={index} value={scale.id}>
                                {scale.value}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={2}  style={{display : props.isDisabled ===true ? 'none' : 'block'}}>
            <Tooltip arrow title="This features available in a future release ">
            <span className={classes.assist}>
                    {<Icon.Help style={{ fontSize: '16px', position: 'relative', top: '3px' }} />}
                    {t('PHASERESOLVEDGRAPH.ASSIST')}
                </span>
                </Tooltip>
                </Grid>

            <Grid item xs={2} style={{display : props.isDisabled === true ? 'none' : 'block'}}>
                <Button variant="contained" disabled
                    startIcon={<Icon.GetApp />}
                    style={{
                        float: 'right',
                        backgroundColor: PXBColors.blue[50],
                        marginTop: '9px',
                        cursor: 'pointer',
                        color: '#fff',
                        opacity: '1',
                        padding:'7px'
                    }}
                >
                    {t('INSULGARD.EXPORTDATA')}
                </Button>
            </Grid>
        </>
    );
};
